<template>
    <transition>
        <div id="modal-wrap">
            <div class="popup_wrap">
                <div class="modal-container">
                    <div class="modal-alert-header" :style="{'background-color': headerColor ? headerColor : '#5096f5'}">
                        <div class="modal-alert-header-text">가이드 ({{currentNumber+1}}/{{maxLength}})</div>
                        <div class="modal-alert-header-close" @click="$emit('close')"></div>
                    </div>
                    <div class="popup_inner">
                        <div class="popup_content_wrap">
                            <div class="popup_content">
                                <!-- {{guideData[currentNumber]}} -->
                                <div class="guide_thum content_image" :class="{'image-and-text' : guideData[currentNumber].guide_ty == 3 ? true : false}" v-if="guideData[currentNumber].guide_ty == 2 || guideData[currentNumber].guide_ty == 3">
                                    <img :src="replacePath(guideData[currentNumber].guide_img_url)">
                                </div>
                                <div class="guide_thum content_youtube" v-if="guideData[currentNumber].guide_ty == 4">
                                    <iframe width="560" height="315" :src="guideData[currentNumber].guide_img_url"  frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                                </div>
                                <div class="guide_thum content_youtube" v-if="guideData[currentNumber].guide_ty == 5">
                                    <video controls :src="guideData[currentNumber].guide_img_url" />
                                </div>

                                <div class="guide_txt" 
                                    :class="{'image-and-text' : guideData[currentNumber].guide_ty == 3 ? true : false}" 
                                    v-if="guideData[currentNumber].guide_ty == 1 || guideData[currentNumber].guide_ty == 3"
                                    :style="{overflow: 'auto', 'max-height': maxHeight+'px'}"
                                >
                                    <pre class="content_pre">{{guideData[currentNumber].guide_cn}}</pre>
                                </div>
                            </div>
                            <div class="popup_arrow">
                                <a href="javascript:void(0);" @click.prevent="prev" class="prev" v-if="currentNumber > 0"><img src="https://s3.ap-northeast-2.amazonaws.com/logicong-web-resources/responsive/modal/study/hint_left.png" alt="이전" /><span class="ir">이전</span></a>
                                <a href="javascript:void(0);" @click.prevent="next" class="next" v-if="currentNumber < maxLength-1"><img src="https://s3.ap-northeast-2.amazonaws.com/logicong-web-resources/responsive/modal/study/hint_right.png" alt="다음" /><span class="ir">다음</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </transition>
</template>
<script>
export default {
    name: 'ModalLearningGuideFull',
    props: ['text','imageSrc','text', 'headerColor'],
    data() {
        return {
            currentNumber: 0,
            maxLength: 0,
            maxHeight: 0,
        }
    },
    created () {
        this.maxLength = _.size(this.guideData);
        if(!this.guideData && this.maxLength < 1){
            console.log('가이드가 없어요');
        }
        this.maxHeight = Number(window.innerHeight) - 84 - 45;
    },
    methods: {
        parentFunc(){
            this.funcData();
        },
        next() {
            if(this.currentNumber >= this.maxLength-1){
                return;
            }
            this.currentNumber += 1
        },
        prev() {
            if(this.currentNumber <= 0){
                return;
            }
            this.currentNumber -= 1
        },
        isVideo(filename) {
            var _fileLen = filename.length;
            var _lastDot = filename.lastIndexOf('.');
            var _fileExt = filename.substring(_lastDot, _fileLen).toLowerCase();
            if(_fileExt === '.mp4'){
                return true;
            }else{
                return false;
            }
                // return _fileExt;
            
        },
        replacePath(filename){
            var replacePath = filename.replace('/data/ESOF/www/','/');
            return replacePath;
        }
    }
}
</script>
<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        position:relative;
        min-height:503px;
        height:95%;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        margin-top: -65px;
    }
    .modal-alert-header{
        display: flex;
        background-color: #34b6d4;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .modal-alert-header-text {
        display: inline-block;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        margin: 0 26px;
        height: 54px;
        line-height: 54px;
        font-family: nanumBarunLight;
        font-size: 18px;
        color: #fff;
    }
    .modal-alert-header-close{
        display: inline-block;
        cursor: pointer;
        right: 0;
        margin: 16px 26px 0 0;
        width: 22px;
        height: 22px;
        background-image: url('../../../assets/images/popupClose.png');
        background-repeat: no-repeat;
    }
    .modal-alert-body {
        height:454px;
        display: block;
        position:relative;
    }
    .modal-alert-body-inner{
        display:inline-block;
        position:relative;
        width:100%;
        height:100%;
        font-family: nanumBarunLight;
        font-size: 16px;
        text-align: center;
        overflow: hidden;
        word-break: break-word;
        padding: 34px 96px;
    }
    .modal-default-button {
        float: right;
    }
    .modal-btn-default{
        display: inline-block;
        width: 105px;
        height: 40px;
        margin: 29px 10px 30px;
        border-radius: 3px;
        border: 1px solid #5848b8;
        color: #fff;
        background-color: #6e5ae6;
        text-align: center;
        line-height: 40px;
        font-family: nanumBarunLight;
        font-size: 16px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .modal-btn-default.modal-btn-cancle{
        background-color: #d8d8d8;
        border: 1px solid #9b9b9b;
        color: #3b3b3b;
    }
    .modal-enter {
        opacity: 0;
    }
    .modal-leave-active {
        opacity: 0;
    }
    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    .btn-guide-nav {
        position: absolute;
        top:0;
        bottom:0;
        margin:auto;
        width: 60px;
        height: 60px;
        border-radius: 30px;        
    }
    .btn-guide-left {
        
        /* left:10px; */
        background: url(https://s3.ap-northeast-2.amazonaws.com/logicong-web-resources/responsive/modal/study/hint_left.png) center no-repeat;
        background-size: contain;
    }
    .btn-guide-right{

        /* right:10px; */
        background: url(https://s3.ap-northeast-2.amazonaws.com/logicong-web-resources/responsive/modal/study/hint_right.png) center no-repeat;
        background-size: contain;
    }
    .modal-guide-main {
        width:450px;
        margin:0 auto;
    }
    .modal-guide-main > div {
        display: inline-block;
    }
    .modal-guide-contents-img {
        width:300px; 
        margin:auto;
    }
    .modal-guide-contents-img > img {
        min-height:180px;
        max-height:300px; 
        margin:auto;
    }    
    .modal-guide-contents-text {
        display: inline-block;
        width:135px;
        margin-left:10px;
    }
    .modal-inner {
        width:800px;
        height:454px;
        margin:0 auto;
        background-color:#f1f1f1;
        position:relative;
    }
    .modal-inner .inner-hint-left {
        position: absolute;
        left:0;
        top:0;
        bottom:0;
        width:100px;
        /* background-color:#cccccc; */
        background-image:url('https://s3.ap-northeast-2.amazonaws.com/logicong-web-resources/responsive/modal/study/hint_left.png');
        background-size: 60px;
        background-repeat:no-repeat;
        background-position: center center;
    }
    .modal-inner .inner-hint-right {
        position: absolute;
        right:0;
        top:0;
        bottom:0;
        width:100px;
        /* background-color:#cccccc; */
        background-image:url('https://s3.ap-northeast-2.amazonaws.com/logicong-web-resources/responsive/modal/study/hint_right.png');
        background-size: 60px;
        background-repeat:no-repeat;
        background-position: center center;
    }
    .modal-body-inner {
        /* width:600px; */
        height:454px;
        padding:0 100px;
        background-color:#ffffff;
    }
    .modal-body-inner-slide {
        height:454px;
        display:-webkit-box;
        display:-ms-flexbox;
        display:flex;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex-grow: 1;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .modal-body-inner-slide > div {
        -webkit-box-orient: horizontal;
        -ms-flex-direction: row;
        flex-direction: row;
    }
    .modal-body-inner-slide .modal-body-inner-img {
        width:300px;
        height:300px;
    }
    .modal-body-inner-slide .modal-body-inner-text {
        width:170px;
        height:300px;
        display:-webkit-box;
        display:-ms-flexbox;
        display:flex;
        
    }
    .modal-body-inner-slide .modal-body-inner-text > pre {
        width:170px;
        /* text-align: center; */
        white-space: pre-wrap; /* CSS3*/
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-all; /* Internet Explorer 5.5+ */ 
    }
    #modal-wrap {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
    .popup_wrap { position:relative; display: table-cell; vertical-align: middle; }
    .modal-container {
        margin: 0px auto;
        /* padding: 20px 30px; */
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        min-width: 820px;
        max-width: 95%
    }
    /* .popup_wrap .popup_close {  } */
    .popup_wrap .popup_inner { padding:0 15px }
    .popup_wrap .popup_inner .popup_content_wrap { position:relative }
    .popup_wrap .popup_content { padding:15px 20px; display:table; width:100%; min-height:450px }
    /* .popup_wrap .popup_content > * { width:50%; display:table-cell; vertical-align:top; margin: auto; text-align: center} */
    .popup_wrap .popup_content .guide_thum { padding-left:30px; padding-right:30px; }
    .popup_wrap .popup_content .guide_txt { padding-left:30px; padding-right:30px;  }
    .popup_wrap .popup_content .guide_txt strong { display:block; margin-bottom:10px; color:#42506d; font-size:18px; font-weight:500; line-height:1 }
    .popup_wrap .popup_content .guide_txt p { word-break:keep-all; font-size:14px; line-height:21px  }
    .popup_wrap .popup_arrow > a { position:absolute; top:45%; width: 50px }
    .popup_wrap .popup_arrow .prev { left:-15px; margin-left: 15px }
    .popup_wrap .popup_arrow .next { right:-15px; margin-right: 15px }
    .paging { font-size:16px; color:#4d4d4d; font-weight:400 }
    .paging .current { color:#42506d; font-weight:500;  }
    .guide_thum > video { 
        max-height: 400px
    }
    .guide_thum {
        width:50%; 
        display:table-cell; 
        vertical-align:top;
        margin: auto;
    }
    .content_youtube { 
        vertical-align:middle; 
        text-align: center
    }
    .content_image {
        vertical-align:middle; 
        text-align: center
    }
    .content_pre {
        
        word-wrap: break-word;
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-break:break-all;
    }
</style>